import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import authStore from '../../auth/auth-store'
import setConvoQuery from './set-convo-query'
import { IUser } from '../../../model/user'
import feedStore from '../../feed/feed-store'

export default async function toggleCreatedByUser(context: BareActionContext<ConvoState, RootState>)
{
  const form = convoStore.state.convoSearchForm
  form.createdByFollowing = false
  form.createdByMe = false
  console.log('searchUser: %j', feedStore.state.feedUser)
  console.log('authhUser: %j', authStore.state.user)
  if (!feedStore.isCurrentUser && !form.createdByUser) {
    form.likedByUser = true
  }

  setConvoQuery(context)

  return
}
